
import VueI18n from 'vue-i18n';
import { Component, Prop, VModel, Vue } from 'vue-property-decorator';
import i18n from '@/plugins/VueI18n';

// SVG
import SearchSVG from '@/assets/search.svg';
import CrossSVG from '@/assets/cross.svg';

// Components
import VInput from '@/components/VInput.vue';
import VButtonIcon from '@/components/VButton/VButtonIcon.vue';
import VSpinner from '@/components/VSpinner.vue';

@Component({
    inheritAttrs: false,
    components: {
        SearchSVG,
        CrossSVG,

        VInput,
        VButtonIcon,
        VSpinner,
    },
})
export default class VSearch extends Vue {
    @VModel({ type: String })
    public search!: string;

    @Prop({ type: String, default: i18n.t('components.search.placeholder') })
    public placeholder!: string | VueI18n.TranslateResult;

    @Prop({ type: Boolean, default: false })
    public loading!: boolean;

    @Prop({ type: Boolean, default: true })
    public borderless!: boolean;

    get listeners() {
        return { ...this.$listeners };
    }

    public clearSearch() {
        this.search = '';
        this.$emit('clear');
    }
}
